import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { CLOUD_PATHS } from './paths';

/** Managed-сервисы облака: облако (Material Icons «cloud», Apache 2.0). */
export const CloudIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {CLOUD_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
